import { render, staticRenderFns } from "./setDepart.vue?vue&type=template&id=0fd01b04"
import script from "./setDepart.vue?vue&type=script&lang=js"
export * from "./setDepart.vue?vue&type=script&lang=js"
import style0 from "./setDepart.vue?vue&type=style&index=0&id=0fd01b04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports